import React, { Component } from "react";
import Axios from "axios";
import { configuration } from "../../appConfig";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { Modal, ModalBody } from "reactstrap";

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CustomerInfoTable_new extends Component {
    state = {
        data: {},
        orderNumber: "",
        words: {},
        lang: "gb",
        kilometerStand: '',
        comment: '',
        manufacturer: '',
        regNo: '',
        model: '',
        color: '',
        Name: '',
        estimateId: '',
        jsondata: [],
        contractor: "",
        ScannerLocation: "",
        actualVIN: "",
        claimNumber: "",
        customerCompany: "",
        modal_break: false,
        Authorized: false
    };
    getLang = () => {
        const base_url = window.location.origin;
        Axios.get(`${base_url}/lang.json`).then((res) => {
          this.setState({
            words: res.data,
            lang: localStorage.getItem("lang"),
          });
        });
      };
      lang = (word) => {
        const { lang, words } = this.state;
    
        return words[word] ? words[word][lang] : word;
      };
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.lang !== prevState.lang) {
            return { lang: nextProps.lang };
        } else return null;
    }
    componentDidMount() {
        this.customerInfo();
        this.getLang();
        this.updateFinalData()
    }


    updateFinalData() {
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");

        Axios.get(
            `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
        ).then((r) => {
            if (r.data) {
                this.setState({
                    jsondata: r.data,
                    manufacturer: r.data.Make || '',
                    regNo: r.data.RegNo || '',
                    model: r.data.Model || '',
                    color: r.data.Color || '',
                    Name: r.data.PartnerName || '',
                    comment: r.data.Comments || '',
                    estimateId: r.data.OrderNo || '',
                    contractor: r.data.contractor || r.data.Client || '',
                    actualVIN: r.data.ActualVin || '',
                    Authorized: r.data.Authorized || false,
                    ScannerLocation: r.data.ScannerLocation || '',
                    // contractor: r.data.Client || '',
                    claimNumber: r.data.ClaimNo || '',
                    customerCompany: r.data.CustomerCompany || '',
                    kilometerStand: r.data.KilometerReading || '',
                })
            }
        })
            .then(async () => {
                if (partnerId) {
                    const res = await Axios.get(
                        configuration.getSingleQRDetails +
                        "?partnerId=" +
                        partnerId +
                        "&vin=" +
                        vin + "&qr_type=" + 1
                    );
                    if (res.data.data.length) {
                        this.setState({
                            estimateId: (!this.state.estimateId ? (res.data.data[0].estimateId || '') : this.state.estimateId),
                            manufacturer: (!this.state.manufacturer ? (res.data.data[0].make || '') : this.state.manufacturer),
                            regNo: (!this.state.regNo ? (res.data.data[0].reg || '') : this.state.regNo),
                            model: (!this.state.model ? (res.data.data[0].model || '') : this.state.model),
                            color: (!this.state.color ? (res.data.data[0].color || '') : this.state.color),
                            Name: (!this.state.Name ? (res.data.data[0].customerName || '') : this.state.Name),
                            comment: (!this.state.comment ? (res.data.data[0].comment || '') : this.state.comment),
                            contractor: (!this.state.contractor ? (res.data.data[0].client || '') : this.state.contractor),
                            claimNumber: (!this.state.claimNumber ? (res.data.data[0].claimNumber) : this.state.claimNumber),
                            customerCompany: (!this.state.customerCompany ? (res.data.data[0].customerCompany) : this.state.customerCompany),
                            actualVIN: (!this.state.actualVIN ? (res.data.data[0].vin || '') : this.state.actualVIN),
                            InsurenceName: res.data.data[0].InsurenceName || ''
                        });
                        // this.props.fullData.Client = (!this.state.contractor ? (res.data.data[0].client || '') : this.state.contractor)
                        // this.props.fullData.ClaimNo = (!this.state.claimNumber ? (res.data.data[0].claimNumber) : this.state.claimNumber)
                        // this.props.fullData.CustomerCompany = (!this.state.customerCompany ? (res.data.data[0].customerCompany) : this.state.customerCompany)
                        // this.props.fullData.RegNo = (!this.state.regNo ? (res.data.data[0].reg || '') : this.state.regNo)
                        // this.props.fullData.Make = (!this.state.manufacturer ? (res.data.data[0].make || '') : this.state.manufacturer)
                        // this.props.fullData.ActualVin = (!this.state.actualVIN ? (res.data.data[0].vin || '') : this.state.actualVIN)
                        // this.props.fullData.Model = (!this.state.model ? (res.data.data[0].model || '') : this.state.model)
                        // this.props.fullData.Color = (!this.state.color ? (res.data.data[0].color || '') : this.state.color)
                        // this.props.fullData.PartnerName = (!this.state.customerName ? (res.data.data[0].customerName || '') : this.state.customerName)
                        // this.props.fullData.Comments = (!this.state.comment ? (res.data.data[0].comment || '') : this.state.comment)
                        // localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
                    }
                }
            })
            .then(async () => {
                if (partnerId) {
                    const res = await Axios.get(
                        configuration.getCustomerInfo +
                        "?partnerId=" +
                        partnerId +
                        "&vin=" +
                        vin
                    );
                    if (res.data.length) {
                        this.setState({
                            data: res.data[0],
                            kilometerStand: (!this.state.kilometerStand) ? (res.data[0].kilometerStand || "") : this.state.kilometerStand,
                            estimateId: (!this.state.estimateId ? (res.data[0].orderid || '') : this.state.estimateId),
                            manufacturer: (!this.state.manufacturer ? (res.data[0].manufacturer || '') : this.state.manufacturer),
                            regNo: (!this.state.regNo ? (res.data[0].regNo || '') : this.state.regNo),
                            model: (!this.state.model ? (res.data[0].model || '') : this.state.model),
                            color: (!this.state.color ? (res.data[0].color || '') : this.state.color),
                            Name: (!this.state.Name ? (res.data[0].Name || '') : this.state.Name),
                            comment: (!this.state.comment ? (res.data[0].comment || '') : this.state.comment),
                            contractor: (!this.state.contractor ? (res.data[0].contractor || '') : this.state.contractor),
                            InsurenceName: res.data[0].InsurenceName || ''
                        });
                        localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
                    }
                }
            }).catch((err) => console.log(err))
    }

    customerInfo = async () => {
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        if (partnerId) {
            const res = await Axios.get(
                configuration.getCustomerInfo +
                "?partnerId=" +
                partnerId +
                "&vin=" +
                vin
            );
            if (res.data.length) {
                this.setState({
                    data: res.data[0],
                    orderNumber: res.data[0].orderid,
                });
                // localStorage.setItem("isScanListRecord", res.data[0].isScanListRecord);
                localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
            } else {
                let clr = {
                    vinNumber: "",
                    manufacturer: "",
                    customerNumber: "",
                    emailAddress: "",
                    Name: "",
                    model: "",
                    street: "",
                    color: "",
                    regNo: "",
                    customerCity: "",
                    postalCode: "",
                    abc: "",
                };
                this.setState({ data: clr });
            }
        } else {
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        })
        // if (name === 'contractor') {
        //     this.props.fullData.Client = value
        // } else if (name === 'claimNumber') {
        //     this.props.fullData.ClaimNo = value
        // } else if (name === 'customerCompany') {
        //     this.props.fullData.CustomerCompany = value
        // } else if (name === 'regNo') {
        //     this.props.fullData.RegNo = value
        // } else if (name === 'manufacturer') {
        //     this.props.fullData.Make = value
        // } else if (name === 'actualVIN') {
        //     this.props.fullData.ActualVin = value
        // } else if (name === 'model') {
        //     this.props.fullData.Model = value
        // } else if (name === 'kilometerStand') {
        //     this.props.fullData.kilometerStand = value
        // } else if (name === 'color') {
        //     this.props.fullData.Color = value
        // } else if (name === 'ScannerLocation') {
        //     this.props.fullData.ScannerLocation = value
        // } else if (name === 'Name') {
        //     this.props.fullData.PartnerName = value
        // } else if (name === 'comment') {
        //     this.props.fullData.Comments = value
        // }
        // this.props.updateJsonData(this.props.fullData);
    }

    handleSave = () => {
        // make api req here
        const { data, jsondata } = this.state;
        this.setState({
            modal_break: true
        });
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        const url = configuration.PostCustomerInfo +
            "?partnerId=" +
            partnerId +
            "&vin=" +
            vin.split("_")[0];
        const qrUrl = configuration.updateQRInfo + "?partnerId=" + partnerId + "&vin=" + vin.split("_")[0];
        const updatedData = {
            "Name": this.state.Name,
            "color": this.state.color,
            "comment": this.state.comment,
            "kilometerStand": this.state.kilometerStand,
            "customerCity": data.customerCity || "",
            "customerNumber": data.customerNumber || "",
            "emailAddress": data.emailAddress || "",
            "manufacturer": this.state.manufacturer,
            "model": this.state.model,
            "partnerId": partnerId,
            "postalCode": data.postalCode || "",
            "regNo": this.state.regNo,
            "vinNumber": vin,
            "street": "",
            "estimateId": this.state.estimateId,
        }
        let qrPayload = {
            ...updatedData,
            'InsurenceName': this.state.InsurenceName || "",
        };
        Axios.post(qrUrl, qrPayload)
            .then((res) => {
                if (res.data) {
                    Axios.post(url, updatedData).then((res) => {
                        this.state.jsondata.PartnerName = this.state.Name;
                        this.state.jsondata.Color = this.state.color;
                        this.state.jsondata.Comments = this.state.comment;
                        this.state.jsondata.kilometerStand = this.state.kilometerStand;
                        this.state.jsondata.Make = this.state.manufacturer;
                        this.state.jsondata.Model = this.state.model;
                        this.state.jsondata.RegNo = this.state.regNo;
                        this.state.jsondata.OrderNo = this.state.estimateId;
                        this.state.jsondata.ActualVin = this.state.actualVIN;
                        //   this.state.jsondata.contractor = this.state.contractor;
                        this.state.jsondata.ScannerLocation = this.state.ScannerLocation;

                        this.setState({ jsondata: this.state.jsondata });
                          Axios.get(
                            `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`)
                          .then((r) => {
                            if (r.data) {
                                let payload = {
                                    ...r.data,
                                    PartnerName : this.state.Name,
                                    Color : this.state.color,
                                    Comments : this.state.comment,
                                    kilometerStand : this.state.kilometerStand,
                                    Make : this.state.manufacturer,
                                    Model : this.state.model,
                                    RegNo : this.state.regNo,
                                    OrderNo : this.state.estimateId,
                                    ActualVin : this.state.actualVIN,
                                    ScannerLocation : this.state.ScannerLocation,
                                    Client : this.state.contractor,
                                    ClaimNo : this.state.claimNumber,
                                    CustomerCompany : this.state.customerCompany
                                }
                                    const jsonurl =
                                    configuration.PostEditorChanges +
                                    `?partnerId=${localStorage.getItem(
                                        "partnerId"
                                    )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${!jsondata.TabViewUpdated}`;
                            
                                    Axios.post(jsonurl, payload).then(async (res) => {
                                    Toast.fire({
                                        type: "success",
                                        title: "Data saved successfully",
                                    });
                                    this.setState({
                                        modal_break : false
                                      })
                                    })
                            }})
                            .catch((err) => {
                                Toast.fire({
                                    type: "error",
                                    title: "Something went wrong",
                                  });
                                  this.setState({
                                    modal_break : false
                                  })
                            })
                        });
                      }})
                      .catch((err) => 
                      {
                        Toast.fire({
                            type: "error",
                            title: "Something went wrong",
                          })
                          this.setState({
                            modal_break : false
                          })
                      })
                     

    }

    render() {
        const { data, jsondata, Authorized } = this.state;
        const partnerId = localStorage.getItem('partnerId')
        const { viewType } = this.props;
        return (
            <div className={viewType ==="TabView" ? 'contanier-fluid' : 'container'}>
                <div className="row title-row-main">
                    <div className="col-sm-12 col-zero">
                            <h3 className="report-title">
                                {this.lang("General Information")}
                            </h3>
                    </div>
                </div>
                <div className="row d-list-middle customer-info-main new_swiss_table_customer_info">
                    {/* contractor start*/}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Insurance Client")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.contractor}
                                        onChange={this.handleChange}
                                        name='contractor'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                        disabled={Authorized}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.contractor}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* contractor end */}
                    {/* Claim number start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Claim number")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.claimNumber}
                                        onChange={this.handleChange}
                                        name='claimNumber'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                        disabled={Authorized}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.claimNumber}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* claim number end */}
                    {/* insurance company start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Customer Company")}
                                {/* Insurance company */}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.customerCompany}
                                        onChange={this.handleChange}
                                        name='customerCompany'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                        disabled={Authorized}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.customerCompany}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* insurance company end*/}
                    {/* Order Number start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Order NO")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.estimateId}
                                        onChange={this.handleChange}
                                        name='estimateId'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                        disabled
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.estimateId}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* orderNumber end */}
                    {/* License plate start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("License_Plate")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.regNo}
                                        onChange={this.handleChange}
                                        name='regNo'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                        disabled={Authorized}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.regNo}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* License plate end */}
                    {/* Reg Number start */}
                    {/* <div className="col-lg-3 col-md-3 col-sm-6  p-0">
                <div className="text-heading-bold one">
                    <p className="m-0 p-0"> 
                        {this.lang("Reg Number")}
                    </p>
                </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6  p-0">
                <div className="text-heading-light one">
                    {
                    this.props.viewType === 'TabView' ? 
                    <input className="m-0 p-0 font-weight-bold"
                    value={this.state.regNo}
                    onChange={this.handleChange}
                    name='regNo'
                    style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                    /> :
                    <p className="m-0 p-0 font-weight-bold"> 
                        {this.state.regNo}
                    </p>
                    }
                </div>
            </div> */}
                    {/* Reg Number end */}


                    {/* make start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Make")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.manufacturer}
                                        onChange={this.handleChange}
                                        name='manufacturer'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                        disabled={Authorized}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.manufacturer}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* make end */}
                    {/* Chassis number start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("VIN")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.actualVIN}
                                        disabled={!this.props.viewType || Authorized}
                                        onChange={this.handleChange}
                                        name='actualVIN'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                    />
                                    :
                                    <p className="m-0 p-0 font-weight-bold">{this.state.actualVIN || localStorage.getItem("selectedFile").split("_")[0]}</p>
                            }

                        </div>
                    </div>
                    {/* Chassis number end */}
                    {/* model start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Model")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.model}
                                        disabled={!this.props.viewType || Authorized}
                                        onChange={this.handleChange}
                                        name='model'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.model}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* model end */}
                    {/* kilometer stand start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Kilometer Stand")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.kilometerStand}
                                        disabled={!this.props.viewType || Authorized}
                                        onChange={this.handleChange}
                                        name='kilometerStand'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {data.kilometerStand || ""}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* kilometer stand end */}
                    {/* color start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Color")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.color}
                                        disabled={!this.props.viewType || Authorized}
                                        onChange={this.handleChange}
                                        name='color'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.color}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* color end */}
                    {/* scanner start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0 "> {this.lang("Scanner Number")} </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={jsondata.ScannerNo}
                                        onChange={this.handleChange}
                                        name='scannerNumber'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                        disabled
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold" style={{ textTransform: "none" }}>
                                        {jsondata.ScannerNo}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* scanner end */}
                    {/* scanner location start */}
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-bold one">
                            <p className="m-0 p-0">
                                {this.lang("Scanner Location")}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6  p-0">
                        <div className="text-heading-light one">
                            {
                                this.props.viewType === 'TabView' ?
                                    <input className="m-0 p-0 font-weight-bold"
                                        value={this.state.ScannerLocation}
                                        disabled={!this.props.viewType || Authorized}
                                        onChange={this.handleChange}
                                        name='ScannerLocation'
                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                    /> :
                                    <p className="m-0 p-0 font-weight-bold">
                                        {this.state.ScannerLocation}
                                    </p>
                            }
                        </div>
                    </div>
                    {/* scanner location end */}
                    {/* VIN start */}
                    {/* <div className="col-lg-3 col-md-3 col-sm-6  p-0">
                <div className="text-heading-bold one">
                    <p className="m-0 p-0">
                        {this.lang("VIN")}
                    </p>
                </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6  p-0">
                <div className="text-heading-light one">
                    <p className="m-0 p-0 font-weight-bold">
                        { localStorage.getItem('partnerId') === '10-200410' 
                        ? localStorage.getItem("selectedFile")
                        : localStorage.getItem("selectedFile").split("_")[0] }
                    </p>
                </div>
            </div> */}
                    {/* VIN end */}
                    {/* customer name start */}
                    <div className="col-12 p-0">
                        <div className="row p-0">
                            <div className="col-lg-3 col-md-3 col-sm-3 col-12 customer-info-main p-0 m-0">
                                <div className="row new-row p-0 m-0">
                                    <div className="col-12 p-0">
                                        <div className="text-heading-bold one">
                                            <p className="m-0 p-0">{this.lang("Customer Name")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-9 col-12 customer-info-main p-0 m-0">
                                <div className="row p-0 m-0">
                                    <div className="col-12 p-0">
                                        <div className="text-heading-light one">
                                            {this.props.viewType === 'TabView' ? <input className="m-0 p-0 font-weight-bold" value={this.state.Name} disabled={!this.props.viewType || Authorized} onChange={this.handleChange} name='Name'// onBlur={this.handleBlur} 
                                                style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }} /> :
                                                <p className="m-0 p-0 font-weight-bold">
                                                    {this.state.Name}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* customer name end */}
                            {/* notes start */}
                            <div className="col-lg-3 col-md-3 col-sm-3 col-12 customer-info-main p-0 m-0">
                                <div className="row new-row p-0 m-0">
                                    <div className="col-12 p-0">
                                        <div className="text-heading-bold one">
                                            <p className="m-0 p-0">
                                                {this.lang("Notes")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-9 col-12 customer-info-main p-0 m-0">
                                <div className="row p-0 m-0">
                                    <div className="col-12 p-0">
                                        <div className="text-heading-light one">
                                            {
                                                this.props.viewType === 'TabView' ?
                                                    <input className="m-0 p-0 font-weight-bold"
                                                        value={this.state.comment}
                                                        title={this.state.comment}
                                                        disabled={!this.props.viewType || Authorized}
                                                        onChange={this.handleChange}
                                                        // onBlur={this.handleBlur}
                                                        name="comment"
                                                        style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                                    /> :
                                                    <p className="m-0 p-0 font-weight-bold" title={this.state.comment} style={{ textTransform: 'none' }}>
                                                        {this.state.comment ? this.state.comment : ''}
                                                    </p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* notes end */}
                        </div>
                    </div>
                    {
                        this.props.viewType === 'TabView' &&
                        <div className="row px-0">
                            <div className="col-12 text-right px-0">

                                <button
                                    style={{
                                        // padding:'5px',
                                        backgroundColor: '#F20000',
                                        padding: "5px 10px",
                                        color: 'white',
                                        border: "none",
                                        borderRadius: "5px",
                                        fontSize: "16px",
                                    }}
                                    disabled={Authorized}
                                    onClick={this.handleSave}
                                >
                                    {this.lang("Update Info")}
                                </button>
                            </div>
                        </div>
                    }
                </div>
                <Modal centered size="lg" isOpen={this.state.modal_break} className="authorise_modalpopup" backdrop="static"
                    toggle={() => this.setState({ modal_break: false })}>
                    <ModalBody className="text-center">
                        <p className="mb-3 text-message-extra-image"><b>{this.lang("save in progress")}<span className="dot-flashing"></span></b></p>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
const mapStateToProps = (props) => {
    return {
        lang: props.lang
    };
};
export default connect(mapStateToProps)(CustomerInfoTable_new);
